export const mutations = {
  INJECT_MEMBERS(state, payload) {
    state.team.members = payload;
  },
};
